// extracted by mini-css-extract-plugin
export default {"page":"MainLayout_page__9ibQR","main":"MainLayout_main__2hqH5","ppVersion":"MainLayout_ppVersion__pV16E"};